import { Controller } from '@hotwired/stimulus'

// Asks for browser notification permission and reflects the current state in a status element.
//
// Usage:
//   data-controller="notifications-permission"
//   data-notifications-permission-icon-value="/logo.svg"
//   data-notifications-permission-granted-text-value="Autorisees"
//
//   <button data-action="notifications-permission#request">Demander</button>
//   <span data-notifications-permission-target="status"></span>
export default class extends Controller {
  static targets = ['status']
  static values = {
    icon: { type: String, default: '/logo.svg' },
    grantedText: { type: String, default: 'Autorisees' },
    deniedText: { type: String, default: 'Bloquees (modifie les permissions du site)' },
    unsupportedText: { type: String, default: 'Ton navigateur ne supporte pas les notifications.' }
  }

  connect() {
    this.#refresh()
  }

  request() {
    if (!('Notification' in window)) {
      this.#setStatus(this.unsupportedTextValue, 'error')
      return
    }
    if (Notification.permission === 'granted') {
      this.#showSampleNotification()
      this.#setStatus(this.grantedTextValue, 'ok')
      return
    }

    Notification.requestPermission().then((result) => {
      if (result === 'granted') {
        this.#showSampleNotification()
        this.#setStatus(this.grantedTextValue, 'ok')
      } else {
        this.#setStatus(this.deniedTextValue, 'error')
      }
    })
  }

  #refresh() {
    if (!this.hasStatusTarget) return
    if (!('Notification' in window)) {
      this.#setStatus(this.unsupportedTextValue, 'error')
      return
    }
    if (Notification.permission === 'granted') this.#setStatus(this.grantedTextValue, 'ok')
    if (Notification.permission === 'denied') this.#setStatus(this.deniedTextValue, 'error')
  }

  #showSampleNotification() {
    new Notification('Capsens Birthdays', {
      body: 'Les notifications fonctionnent !',
      icon: this.iconValue
    })
  }

  #setStatus(text, kind) {
    if (!this.hasStatusTarget) return

    this.statusTarget.textContent = text
    this.statusTarget.dataset.kind = kind
  }
}
